import axios from "axios";
import { removeLastPayment } from "../store/reducers/accountMetricsSlice";

export const initiatePayment = async (body, idToken) => {
  try {
    const res = await axios.post(`payment/initiate-payment/`, body, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const applyCoupon = async (
  id,
  code,
  idToken,
  type,
  no_activation_fee = false
) => {
  const config = {
    headers: { Authorization: `Bearer ${idToken}` },
    params: { coupon: code, payment_type: type, no_activation_fee },
  };
  const res = await axios.get(`payment/final-price/${id}/`, config);

  if (res.data) return res.data;
};
export const getPaymentStatus = async (idToken, body, dispatch) => {
  let config = {
    headers: { Authorization: `Bearer ${idToken}` },
  };
  try {
    const res = await axios.post(`payment/payment-status/`, body, config);
    res?.status < 399 && dispatch(removeLastPayment());
    return res;
  } catch (err) {
    throw err;
  }
};

export const pushLeads = async (data) => {
  try {
    const response = await axios.post(`affiliates/pushleads/`, data);
    return response;
  } catch (error) {
    console.error("Error pushing leads:", error);
    // Optionally, you can handle different error cases or rethrow the error
    throw error;
  }
};

export const marketUnSubscribe = async (idToken, id) => {
  let config = {
    headers: { Authorization: `Bearer ${idToken}` },
  };
  try {
    const res = await axios.post(
      `subscription/unsubscripe/`,
      { id: id },
      config
    );
    return res;
  } catch (err) {
    throw err;
  }
};
export const marketSubscribe = async (idToken, body) => {
  let config = {
    headers: { Authorization: `Bearer ${idToken}` },
  };
  try {
    const res = await axios.post(
      `payment/market-data-level-payment/`,
      body,
      config
    );
    return res;
  } catch (err) {
    throw err;
  }
};
